import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import { fetchMembershipSchedule } from 'store/actions/membership-schedules/fetchMembershipSchedules';
import { updateMembershipSchedule } from 'store/actions/membership-schedules/updateMembershipSchedules';
import MembershipScheduleCreateForm from '../create/MembershipScheduleCreateForm';

class MembershipScheduleEditContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            id,
        } = this.props;

        return new Promise((resolve) => {
            dispatchForm({
                id: id,
                onError: resolve,
                onSuccess: () => {
                    resolve(history.push(`/membership-schedules/${ id }/show`));
                },
                values: values,
            });
        });
    }

    render() {
        const {
            data,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('menu.sidebar.membership_schedules'),
                link: '/membership-schedules',
            },
            {
                label: data.name,
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.memberships.actions.edit', {
                        title: data.name,
                    }) } />

                    <Actions>
                        <ListButton url={ `/membership-schedules` } />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <MembershipScheduleCreateForm
                            initialValues={ data }
                            form='membership_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

MembershipScheduleEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (payload) => {
            dispatch(updateMembershipSchedule(payload));
        },
    };
};

const enhance = compose(
    connect(
        null,
        mapDispatchToProps,
    ),
    translate,
    fetchResourceById({
        action: fetchMembershipSchedule,
        resource: 'membership-schedules',
    })
);

export default enhance(MembershipScheduleEditContainer);



// WEBPACK FOOTER //
// ./src/pages/membership-schedules/edit/MembershipScheduleEditContainer.js